/*
  德语
*/

export default {
  // 刊登编辑页面 edit
  publishEdit: {
    listings: 'Listen',
    Platform: 'Plattform',
    Store: 'Speichern',
    ProductTitle: 'Titel des Produkts',
    Tags: 'Tags',
    Custom: 'Benutzerdefiniert',
    Collections: 'Sammlungen',
    Description: 'Beschreibung',
    Variants: 'Varianten',
    Images: 'Bilder',
    listNow: 'Liste jetzt',
    CancelEditing: 'Abbrechen der Bearbeitung',
    tips1: 'Keine mehr als 40000 Zeichen',
    tips2: 'Es werden nur JPG-, JPEG- und PNG-Bilder unterstützt.',
    ShippingMethod: 'Art des Versands',
    Product: 'Produkt',
    SKU: 'SKU',
    size: 'Größe',
    color: 'Farbe',
    ProductCost: 'Kosten des Produkts',
    ShippingCost: 'Fracht',
    CompareAtPrice: 'Vergleich der Preise',
    SuggestedPrice: 'Vorgeschlagener Preis',
    Profi: 'Gewinn',
    Quantity: 'Anzahl',
    tips3: 'Einschließlich Reedereien',
    tips4: 'Unterstützt bis zu 250 Bilder',
    tips5: 'Unterstützt bis zu 40 Bilder',
    SuggestedPriceTips1: 'Verkaufspreis=Originalpreis*(1+Markup)+Versandkosten',
    CompareAtPriceTips1: 'Vergleichen Sie zu Preis=Produktkosten * (1+Profit Margin)+Versandkosten',
    SuggestedPriceTips2: '(Wenn Sie "Inklusive Versandkosten" ausgewählt haben)',
    SuggestedPriceTips3: 'Alle Preise mit einem Klick ändern',
    NewPrice: 'Neuer Preis',
    cancel: 'Stornieren',
    confirm: 'bestätigen',
    Percentage: 'Prozentsatz',
    OneClickModification: 'Modifikation mit einem Klick',
    ProductionEditor: 'Produkteditor',
    SyncCollection: 'matching collection',
    selectContent: 'select content',
    ShippingFrom: 'Startpunkt',
    ShippingTo: 'Endpunkt',
    EstimatedDeliveryTime: 'geschätzte Lieferzeit',
    NoPictures: 'Keine Bilder',
    loadingText: 'Laden...',
    repeat: 'Wiederholen!',
    IncorrectLogisticsInformation: 'Versandart kann nicht leer sein',
    PictureCannotBeEmpty: 'Bild kann nicht leer sein',
    SKUCannotBeEmpty: 'SKU kann nicht leer sein',
    inputLength: 'Länge weniger als 255',
    richTextCheck: 'Die Anzahl der reichen Textworte kann 40000 nicht überschreiten',
    CompareAtPriceCheck: 'Der Vergleich zum Preis muss höher sein als der vorgeschlagene Preis',
    CompareAtPriceCheckShoplazza: 'Der Preisvergleich muss höher sein als',
    titleCheck: 'Titel kann nicht leer sein',
    DescriptionCheck: 'Beschreibung kann nicht leer sein',
    ShelfStatusUp: 'Das Produkt wird früh im Shop erhältlich sein',
    ShelfStatusDowm: 'Dieses Produkt wurde zuvor in den Store gelistet.',
    ProfitMargin: 'Marge des Gewinns',
    imageMaxLengthTips: 'Sie können nur bis zu 250 Bilder auswählen',
    imageMaxLengthTips2: 'Sie können nur bis zu 40 Bilder auswählen',
    tagLength: 'Einrichten von bis zu zehn Etiketten',
    isFilterDuplicateSpuText: 'Das gleiche Produkt wird wiederholt aufgeführt',
    beenListed: 'Fehlgeschlagen. Artikel wurden bereits aufgelistet.'
  },
  publishListings: {
    listings: 'Listen',
    Published: 'Veröffentlicht',
    Hidden: 'Versteckt',
    ListingQueue: 'Warteschlange anzeigen',
    Deleted: 'Löschen',
    productSelected: 'Ausgewähltes Produkt',
    Product: 'Produkt',
    ProductId: 'Id des Produkts',
    priceScope: 'price Scope',
    CompareAtPrice: 'Vergleich zu Preis',
    Inventory: 'Bestandsaufnahme',
    EditProduct: 'Produkt bearbeiten',
    More: 'Mehr',
    Synchronous: 'Synchronisation',
    Relist: 'Relikt',
    PublishedIn: 'Veröffentlicht in ...',
    Delete: 'Löschen',
    synType1Title: 'Auf der Liste...',
    synType5Title: 'Auf der...',
    synType4Title: 'Versteckt vor dem Laden...',
    synType10Title: 'In Sync...',
    synType2Title: 'Informationen synchron bearbeiten..',
    noProduct: 'Leider haben Sie kein Produkt hinzugefügt',
    ChooseProduct: 'Produkt auswählen',
    ConnectANewStore: 'Einen neuen Store verbinden',
    hiddenComfirmTitle: 'Sind Sie sicher, dass Sie das Produkt aus dem Store absetzen',
    RelistComfirmTitle: 'Sind Sie sicher, dass Sie das Produkt in den Laden laden?',
    deleteComfirmTitle: 'Sind Sie sicher, dass Sie das Produkt aus Ihrem Shop löschen möchten?',
    synType3Title: 'Löschen Sie die...',
    searchBy: 'Inhalt suchen',
    SelectStore: 'Store auswählen',
    store: 'lagern',
    productName: 'Produktname'
  },
  productList: {
    wishList: 'Wunschliste',
    productList: 'Liste der Produkte',
    Delete: 'Löschen',
    productSelected: 'Ausgewähltes Produkt',
    deleteTip1: 'Sind Sie sicher, das angekreuzte Produkt zu löschen?',
    submit: 'submit',
    cancel: 'Stornieren',
    Description: 'Beschreibung',
    Inventory: 'Bestandsaufnahme',
    Price: 'Preis',
    ProductType: 'Art des Produkts',
    Action: 'Aktion',
    Detail: 'Detail',
    more: 'mehr',
    ListToStore: 'Liste speichern',
    customized: 'individuell',
    goodsInStock: 'Waren auf Lager',
    tatusTips: 'Das Produkt ist nicht verfügbar.',
    canFind: "Sorry, can't find~ Please search again",
    ItemNo: 'Artikel Nr.',
    contentPlaceholder: 'Bitte geben Sie das Produkt-Stichwort ein',
    Listing: 'Auflistung',
    YourPrice: 'Ihr Preis',
    From: 'Von',
    ShipTo: 'Versand an',
    Cancel: 'Abbrechen',
    ListNow: 'Jetzt auflisten',
    Platform: 'Plattform',
    Store: 'Speichern',
    ShipMyOdersMostTo: 'Nächste Lieferung der Bestellung',
    ShippingMethod: 'Versandart',
    logisticsTips: 'Solange Sie einen der Versandorte, den Empfangsort und den Logistikkanal auswählen, müssen Sie alle auswählen.',
    batchPublishTips: 'Laden Sie maximal 100 Einträge auf einmal hoch',
    storeTips: 'Kann jeweils nur in einen Shop hochgeladen werden',
    priceTips: 'Ihr Preis=Preis-Input-Koeffizient (Zeiten statt Kurs eingeben.)',
    shipTips: 'Der gewählte Logistikmodus wird nur als vom System unterstützte Logistik verwendet',
    ShippingMethodTips: 'Optional (Sie können es optimieren, bevor der Versand beginnt)',
    inputPlaceholder: 'Inhalt suchen',
    haveShelves: 'Liste fehlgeschlagen: Nicht verfügbare Elemente enthalten.',
    textareaPlaceholder: 'Mehrere Suchen mit Kommas oder Zeilenumbrüchen trennen',
    repeatListTip: 'Das gleiche Produkt wird wiederholt aufgeführt',
    repeatList: 'Wiederholungsliste',
    priceRatioGT20Tip: 'Das Produkt, das Sie hochladen, wird zum 20-fachen Verkaufspreis hochgeladen',
    yourPrice: 'Ihr Preis'
  },
  batchTasks: {
    batchTasks: 'Stapelaufgaben',
    Status: 'Status',
    contentPlaceholder: 'Suche nach',
    Number: 'Zahl',
    StoreInformation: 'Informationen speichern',
    ItemNo: 'Artikel Nr.',
    PublicationSituation: 'Publikationssituation',
    FailedToLoad: 'Laden fehlgeschlagen',
    Success: 'Erfolg',
    uploading: 'Hochladen',
    ListingFailed: 'Listing fehlgeschlagen',
    CreationTime: 'Erstellungszeit',
    Pending: 'Ausstehend',
    Processing: 'Verarbeitung',
    Completed: 'Abgeschlossen',
    contentPlaceholder2: 'Suche nach Artikel Nr.',
    Platform: 'Plattform',
    Store: 'Speichern',
    Product: 'Produkt',
    ReasonForFailure: 'Grund für das Versagen',
    data: 'Daten'
  }
}
